import React, { useState, useEffect } from "react";
import footerLogo from "../../assets/footerLogo.png";

const Footer = ({ footerData }) => {
  const [menu2, setMenu2] = useState([]);

  useEffect(() => {
    if (footerData) {
      const data = footerData?.menu2[0]?.split(",");
      setMenu2(data);
    }
  }, [footerData]);

  const socialIcons = {
    facebook: (
      <svg
        width="18"
        height="18"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"
          fill="currentColor"
        />
      </svg>
    ),
    linkedin: (
      <svg
        width="18"
        height="18"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"
          fill="currentColor"
        />
      </svg>
    ),
  };

  const SocialIcon = ({ icon, href, label }) => (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      className="w-8 h-8 bg-white/10 hover:bg-white/20 rounded-lg flex items-center justify-center text-white transition-all duration-300 hover:scale-105 group"
      aria-label={label}
    >
      <div className="group-hover:scale-110 transition-transform duration-300">
        {icon}
      </div>
    </a>
  );

  return (
    <footer className="relative bg-gradient-to-br from-slate-900 via-slate-800 to-slate-900 overflow-hidden">
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-5">
        <div className="absolute top-0 left-0 w-full h-full bg-[radial-gradient(circle_at_20%_50%,_white_1px,_transparent_1px)] bg-[length:40px_40px]"></div>
      </div>

      {/* Decorative Elements */}
      <div className="absolute top-0 right-0 w-32 h-32 bg-gradient-to-l from-blue-500/10 to-transparent rounded-full blur-3xl"></div>
      <div className="absolute bottom-0 left-0 w-32 h-32 bg-gradient-to-r from-red-500/10 to-transparent rounded-full blur-3xl"></div>

      {/* Main Content */}
      <div className="relative">
        {/* Desktop Layout */}
        <div className="hidden lg:block">
          <div className="max-w-6xl mx-auto px-8 py-8">
            <div className="grid grid-cols-3 gap-8 items-center">
              {/* Column 1: Logo & Company Name */}
              <div className="flex items-center gap-3">
                <img
                  src={footerLogo}
                  alt="ProSafe Training Logo"
                  className="w-[80px] h-12 object-contain filter"
                />
                <div>
                  <h2 className="text-white text-lg font-bold">
                    ProSafe Training
                  </h2>
                  <p className="text-white/60 text-xs">
                    Professional Safety Training
                  </p>
                </div>
              </div>

              {/* Column 2: Social Media */}
              <div className="flex items-center justify-center gap-3">
                <span className="text-white/60 text-sm mr-2">Follow Us:</span>
                <SocialIcon
                  icon={socialIcons.facebook}
                  href="https://facebook.com"
                  label="Facebook"
                />
                <SocialIcon
                  icon={socialIcons.linkedin}
                  href="https://linkedin.com"
                  label="LinkedIn"
                />
              </div>

              {/* Column 3: Quick Links */}
              <div className="flex flex-col gap-1">
                <a
                  href="#"
                  className="text-white/80 hover:text-white text-xs font-medium transition-colors duration-300"
                >
                  Classroom Code of Conduct
                </a>
                <a
                  href="#"
                  className="text-white/80 hover:text-white text-xs font-medium transition-colors duration-300"
                >
                  Change, Refund & Return Policy
                </a>
                <a
                  href="#"
                  className="text-white/80 hover:text-white text-xs font-medium transition-colors duration-300"
                >
                  Communicable Disease Plan
                </a>
                <a
                  href="#"
                  className="text-white/80 hover:text-white text-xs font-medium transition-colors duration-300"
                >
                  Privacy Policy
                </a>
              </div>
            </div>
          </div>
        </div>

        {/* Mobile Layout */}
        <div className="lg:hidden">
          <div className="px-6 py-6">
            {/* Header Section */}
            <div className="text-center mb-4">
              <img
                src={footerLogo}
                alt="ProSafe Training"
                className="w-10 h-10 object-contain mx-auto mb-2 filter brightness-0 invert"
              />
              <h2 className="text-white text-base font-bold mb-1">
                ProSafe Training
              </h2>
              <p className="text-white/60 text-xs">
                Professional Safety Training
              </p>
            </div>

            {/* Social Media */}
            <div className="text-center mb-4">
              <div className="flex justify-center gap-3 mb-3">
                <SocialIcon
                  icon={socialIcons.facebook}
                  href="https://facebook.com"
                  label="Facebook"
                />
                <SocialIcon
                  icon={socialIcons.linkedin}
                  href="https://linkedin.com"
                  label="LinkedIn"
                />
              </div>
            </div>

            {/* Navigation Links */}
            <div className="text-center">
              <div className="flex flex-col gap-2">
                <a
                  href="#"
                  className="text-white/80 hover:text-white text-xs font-medium transition-colors duration-300"
                >
                  Classroom Code of Conduct
                </a>
                <a
                  href="#"
                  className="text-white/80 hover:text-white text-xs font-medium transition-colors duration-300"
                >
                  Change, Refund & Return Policy
                </a>
                <a
                  href="#"
                  className="text-white/80 hover:text-white text-xs font-medium transition-colors duration-300"
                >
                  Communicable Disease Plan
                </a>
                <a
                  href="#"
                  className="text-white/80 hover:text-white text-xs font-medium transition-colors duration-300"
                >
                  Privacy Policy
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
